import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, Modal, Label, TextInput, Alert, Badge } from "flowbite-react";
import ReusableDataTable from '../../../hooks/ReusableDataTable';
import CustomSelectwithText from '../../../hooks/CustomSelectwithText';
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import CReadytoSewingQuantity from './CReadytoSewingQuantity';
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { AuthContext } from "../../../context/AuthContext";
import { TbCircleLetterRFilled } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { FaRectangleList } from "react-icons/fa6";
import RequestActivityModal from '../../../hooks/RequestActivityModal';

function ReadytoSewing({ orderid, Sub_Order_id }) {
    const [data, setData] = useState([]);
    const [selectedMarker, setselectedMarker] = useState({});
    const [available_quantityFlag, setavailable_quantityFlag] = useState(0);
    const [AddReadytosewing, setAddReadytosewing] = useState(false);
    const [Order, setOrder] = useState({ sizevarientwithquantity: "", buyer_name: "", colour_name: "", style_name: "", orderdate: "", total_piece: 0, cutorderno: "", pono: "", noofbales: "", delivery_date: "" });
    const [Suborder, setSuborder] = useState({ sizevarientwithquantity: "", total_piece: 0 })
    const [Input, setInput] = useState({});
    const today = new Date().toISOString().split('T')[0];
    const [Marker, setMarker] = useState({});
    const [completeStatusKey, setcompleteStatusKey] = useState(0) //for re render
    const [EditModal, setEditModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [requestModal, setrequestModal] = useState(false);


    const [requestActivityModal, setrequestActivityModal] = useState(false);
    const [requestActivityData, setrequestActivityData] = useState({});

    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const role = sessionStorage.getItem('role');

    useEffect(() => {
        if (!user) {
            navigate("/");
        } else {
            fetchorder();
        }
    }, [user, navigate]);

    useEffect(() => {
        fetchorder();
    }, []);

    const fetchmarker = async () => {
        try {
            const response = await axios.get("master/size_variants");
            const markerData = response.data;
            setMarker(markerData);
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };

    const fetchrequestActivity = async (rtsId) => {
        try {
            const response = await axios.get(`/requests/request/${rtsId}`, {
                params: { section_name: 'Ready To Sewing' },
            });
            const requestActivityData = response.data.data;
            console.log(requestActivityData)
            setrequestActivityData(requestActivityData);
        } catch (error) {
            console.error("Error fetching requestActivityData:", error);
        }
    };

    const fetchavailablequantity = async () => {
        try {
            const response = await axios.get(`ready_to_sewing/get_available_quantity/${orderid}/${Sub_Order_id}`);
            const availableQuantityData = response.data.available_quantity;
            setselectedMarker(availableQuantityData);
            setavailable_quantityFlag(response.data.success)
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };

    const fetchsuborder = async () => {
        try {
            const response = await axios.get(`order/suborders_by_suborder_id_size_variant/${Sub_Order_id}`);
            const SubOrderData = response.data;
            //   setSuborder(SubOrderData);
            setSuborder({
                sizevarientwithquantity: SubOrderData.size_variant_quantity,
                total_piece: SubOrderData.total_piece,
            })

        } catch (error) {
            console.error("Error fetching suborder data:", error);
        }
    };


    const sizevariantOptions = Marker.length > 0 ? Marker
        .filter((item) => Suborder.sizevarientwithquantity[item.size_id] != undefined)
        .map((item) => ({
            value: item.size_id,
            label: item.size
        })) : [];

    const fetchorder = async () => {
        try {
            const response = await axios.get(`order/orders/${orderid}`);
            const OrderData = response.data;
            setOrder({
                orderdate: OrderData.order_date,
                total_piece: OrderData.total_piece,
                cutorderno: OrderData.cut_order_no,
                pono: OrderData.job_no,
                noofbales: OrderData.no_of_bales,
                buyer_name: OrderData.buyer_name,
                colour_name: OrderData.colour_name,
                style_name: OrderData.style_name,
                delivery_date: OrderData.delivery_date,
                sizevarientwithquantity: OrderData.size_variant_quantity,
            });

        } catch (error) {
            console.error("Error fetching order data:", error);
        }
    };


    useEffect(() => {
        fetchorder();
        fetchsuborder();
        fetchReadytoSewing();
        fetchmarker();
    }, []);

    //  Fetch all logs
    const fetchReadytoSewing = async () => {
        try {
            const response = await axios.get(`ready_to_sewing/ready_to_sewing/${orderid}/${Sub_Order_id}`);
            const result = response.data;
            const logs = result.logs;
            setData(logs);
        } catch (error) {
            console.error("Error fetching logs:", error);
        }
    };


    //  Add a new log
    const handleSubmit = async (e) => {
        e.preventDefault();

        const totalPiece = Object.values(selectedMarker)
            .map(Number)
            .reduce((acc, value) => acc + value, 0);

        if (Object.keys(selectedMarker).length === 0 || totalPiece === 0) {
            Swal.fire({
                icon: "error",
                text: "Please fill in the size variant quantities and ensure total pieces is greater than 0.",
                type: "error",
                timer: 2000,
                showConfirmButton: false,
            });

        }
        else {
            const requestData = {
                ...Input,
                orderdate: today,
                order_id: orderid,
                sub_order_id: Sub_Order_id,
                size_variant_quantity: selectedMarker,
                total_piece: totalPiece,
                staff_id: user.staff_id,
            };

            try {
                axios
                    .post('ready_to_sewing/ready_to_sewing', requestData)
                    .then((response) => {
                        if (response.data.success === 1) {
                            Swal.fire({
                                icon: "success",
                                text: "Ready To Sew Completed ",
                                type: "success",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                            fetchReadytoSewing();
                            setAddReadytosewing(false);
                            setcompleteStatusKey((prevKey) => prevKey + 1);
                            setavailable_quantityFlag(0);
                        }
                        else if (response.data.success === 2) {
                            Swal.fire({
                                icon: "error",
                                text: "Quantity  exceeds the allowed limit....",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });

                        }
                        else if (response.data.success === 3) {
                            Swal.fire({
                                icon: "error",
                                text: "The cutting section has not been completed.",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                text: "Server Problem. Please Try Again...",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                        }
                        return;
                    });
            } catch (error) {
                throw error;
            }
        }
    };


    //  Add Request
    const handleRequest = async (e) => {
        e.preventDefault();

        setrequestModal(false)
        const requestData = {
            ...Input,
            order_id: orderid,
            sub_order_id: Sub_Order_id,
            staff_id: user.staff_id,
            section_name: 'Ready To Sewing',
            section_id: Input.id,
            reason: Input.reason
        };


        try {
            axios
                .post('ready_to_sewing/ready_to_sewing/request', requestData)
                .then((response) => {
                    if (response.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Requested",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        fetchReadytoSewing();
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }
    };


    const handleUpdate = async () => {
        const totalPiece = Object.values(selectedMarker)
            .map(Number)
            .reduce((acc, value) => acc + value, 0);

        if (Object.keys(selectedMarker).length === 0 || totalPiece === 0) {
            Swal.fire({
                icon: "error",
                text: "Please fill in the size variant quantities and ensure total pieces is greater than 0.",
                type: "error",
                timer: 2000,
                showConfirmButton: false,
            });

        }
        else {

            try {
                axios
                    .put(`ready_to_sewing/ready_to_sewing/${Input.id}`, {
                        "date": Input.date,
                        "markerwithquantity": selectedMarker,
                        "totalpiece": totalPiece,
                        "remark": Input.remark,
                        // "staff_id": user.staff_id,
                    })
                    .then((response) => {
                        if (response.data.success === 1) {
                            Swal.fire({
                                icon: "success",
                                text: "Updated successfully!",
                                type: "success",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                            fetchReadytoSewing();
                            setEditModal(false);
                            setInput({});
                            setcompleteStatusKey((prevKey) => prevKey + 1);
                        }
                        else if (response.data.success === 2) {
                            Swal.fire({
                                icon: "error",
                                text: "Quantity  exceeds the allowed limit....",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });

                        }
                        else if (response.data.success === 3) {
                            Swal.fire({
                                icon: "error",
                                text: "The cutting section has not been completed.",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                text: "Server Problem. Please Try Again...",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                        }
                        return;
                    });
            } catch (error) {
                throw error;
            }
        }

    };

    const handleDelete = async () => {
        try {
            axios.delete(`ready_to_sewing/ready_to_sewing/${Input.id}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Customer  deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchReadytoSewing();
                    setDeleteModal(false);
                    setcompleteStatusKey((prevKey) => prevKey + 1);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };

    const onChangeValue = (e) => {
        setInput({ ...Input, [e.target.name]: e.target.value });
    };

    const columns = [
        { name: "#", selector: (row) => row.sno, sortable: true },
        { name: "Date", selector: (row) => row.date, sortable: true },
        { name: "Staff Name", selector: (row) => row.staffname, sortable: true },
        { name: "Size with quantity", selector: (row) => row.formatedmarkerwithquantity, sortable: true },
        { name: "Total Piece", selector: (row) => row.totalpiece, sortable: true },
        { name: "Remark", selector: (row) => row.remark, sortable: true },
        {
            name: "Created at",
            selector: (row) => {
                const date = new Date(row.datetime);
                return [`${date.toLocaleDateString("en-GB")}`, `${date.toLocaleTimeString("en-GB", { hour12: false })}`];
            },
            sortable: true,
            cell: (row) => (
                <div>
                    <div>{new Date(row.datetime).toLocaleDateString("en-GB")}</div>
                    <div>{new Date(row.datetime).toLocaleTimeString("en-GB", { hour12: false })}</div>
                </div>
            )
        },

        ...(role === 'Cutting_Staff' || role === 'super_admin' || role === 'FM' ? [{ name: "Option", selector: (row) => row.option }]
            : [])
    ];
    const Data = data?.map((plan, index) => {
        const currentDate = new Date().toLocaleDateString('en-GB');
        const planDate = new Date(plan.datatime).toLocaleDateString('en-GB');
        return {
            sno: index + 1,
            id: plan.rts_log_id,
            date: new Date(plan.date).toLocaleDateString('en-GB'),
            formatedmarkerwithquantity: plan.formated_size_variant,
            markerwithquantity: plan.formated_size_variant,
            totalpiece: plan.total_piece,
            datetime: plan.datatime,
            staffname: plan.staff_name,
            remark: plan.remark,
            option: (
                <div style={{ display: "flex" }}>
                    {(role === 'super_admin' || ((role === 'Cutting_Staff' || role === 'FM') && currentDate === planDate) || ((role === 'FM' && plan.request_status == 'accepted'))) && (
                        <>
                            <FaPen
                                className="text-amber-400 text-xl cursor-pointer"
                                onClick={() => {
                                    setInput({
                                        id: plan.rts_log_id,
                                        date: new Date(plan.date).toISOString().split('T')[0],
                                        markerwithquantity: plan.size_variant_quantity,
                                        totalpiece: plan.total_piece,
                                        remark: plan.remark,
                                    });
                                    setselectedMarker(plan.size_variant_quantity);
                                    setEditModal(true);
                                }}
                            />

                            <MdDeleteForever
                                className="ml-2 text-red-500 text-2xl"
                                onClick={() => {
                                    setInput({ id: plan.rts_log_id });
                                    setDeleteModal(true);
                                }}
                            />
                        </>

                    )}

                    {(role === 'FM' && currentDate !== planDate && plan.request_status != 'accepted') && (

                        <TbCircleLetterRFilled
                            className="text-green-500 text-xl "
                            onClick={() => {
                                // handleRequest(plan.rts_log_id)
                                (plan.request_status == 'request' || plan.request_status == "rejected") && setrequestModal(true); setInput({ id: plan.rts_log_id });
                            }}
                            style={{
                                color: plan.request_status == 'requested' ? "grey" : "green",
                                cursor: plan.request_status == 'requested' ? "not-allowed" : "pointer",
                            }}
                        />

                    )}

                    <FaRectangleList
                        className="pl-1 text-blue-500 text-2xl"
                        onClick={() => {
                            fetchrequestActivity(plan.rts_log_id);
                            setrequestActivityModal(true);

                        }}
                    />
                </div>
            )

        };
    }) || [];

    return (
        <>
            {(role === 'Cutting_Staff' || role === 'super_admin' || role === 'FM') &&
                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" onClick={() => { setAddReadytosewing(true); fetchavailablequantity(); }}>
                    Add Ready to Sew
                </Button>}

            <CReadytoSewingQuantity key={completeStatusKey} orderid={orderid} Sub_Order_id={Sub_Order_id} />
            <div className="overflow-x-auto mt-2">
                <ReusableDataTable columns={columns} data={Data} />
            </div>

            <Modal show={AddReadytosewing} size="md" onClose={() => { setAddReadytosewing(false); setselectedMarker({}); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Add Ready to Sew</h3>
                        <form onSubmit={handleSubmit}>

                            {available_quantityFlag === 1 && (
                                <Alert color="failure" className="mt-2">
                                    Cutting section has not completed
                                </Alert>
                            )}

                            {available_quantityFlag === 2 && (
                                <Alert color="failure" className="mt-2">
                                    Unable to add. The cutting quantity has already been fully transferred to ready-to-sewing.
                                </Alert>
                            )}

                            {available_quantityFlag !== 1 && available_quantityFlag !== 2 && (
                                <>
                                    <div className="pt-2">
                                        <Label htmlFor="orderdate" value="Date" />
                                        <TextInput
                                            name="orderdate"
                                            type="date"
                                            required
                                            autoComplete="off"
                                            value={today} // set default value
                                            min={sessionStorage.getItem("role") === "super_admin" ? "" : today}
                                            max={today}
                                            onChange={onChangeValue}
                                        />
                                    </div>

                                    <div className="pt-2">
                                        <Label htmlFor="sizeVariant" value="Size with quantity" />
                                        <CustomSelectwithText
                                            value={selectedMarker}
                                            onChange={(selectedOptions) => setselectedMarker(selectedOptions)}
                                            options={sizevariantOptions}
                                            id="size-variant-select"
                                            name="sizeVariant"
                                        />
                                    </div>

                                    <div className="pt-2">
                                        <Label htmlFor="remark" value="Remark" />
                                        <TextInput
                                            name="remark"
                                            type="text"
                                            // required
                                            autoComplete="off"
                                            onChange={onChangeValue}
                                        />
                                    </div>

                                    <div className="pt-3 w-full flex justify-center">
                                        <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit">
                                            Submit
                                        </Button>
                                        <Button
                                            className="ml-2"
                                            color="gray"
                                            onClick={() => {
                                                setAddReadytosewing(false);
                                                setselectedMarker({});
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </>
                            )}
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={EditModal} size="md" onClose={() => setEditModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <form onSubmit={(e) => { e.preventDefault(); handleUpdate(); }}>
                        <div className="space-y-6">
                            <h3 className="text-xl font-medium text-gray-900">Update Ready To Sew</h3>

                            <div className="pt-2">
                                <Label htmlFor="date" value="Date" />
                                <TextInput
                                    name="date"
                                    type="date"
                                    autoComplete="off"
                                    value={today}
                                    min={sessionStorage.getItem("role") === "super_admin" ? "" : today}
                                    max={today}  // disable future dates
                                    required
                                    onChange={onChangeValue}
                                />
                            </div>

                            <div className='pt-2'>
                                <Label htmlFor="sizeVariant" value="Size with quantity" />
                                <CustomSelectwithText
                                    value={selectedMarker}
                                    onChange={(selectedOptions) => setselectedMarker(selectedOptions)}
                                    options={sizevariantOptions}
                                    id="size-variant-select"
                                    name="sizeVariant"
                                />
                            </div>

                            <div className="pt-2">
                                <Label htmlFor="remark" value="Remark" />
                                <TextInput
                                    name="remark"
                                    type="text"
                                    value={Input.remark || ''}
                                    // required
                                    onChange={onChangeValue}
                                />
                            </div>

                            <div className="mt-2 flex justify-center">
                                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit">Submit</Button>
                                <Button color="gray" className="ml-2" onClick={() => setEditModal(false)}>
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500">
                            Are you sure you want to delete this Ready To Sew?
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="failure" onClick={() => handleDelete()}>
                                Yes
                            </Button>
                            <Button color="gray" onClick={() => setDeleteModal(false)}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={requestModal}
                size="md"
                onClose={() => setrequestModal(false)}
                popup
            >
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to request admin access for editing?
                        </h3>

                    </div>
                    <div className="space-y-6">

                        <form>
                            <div>
                                <div className="pt-2 text-left mb-2 block">
                                    <Label htmlFor="completed-date" value="Reason" />
                                </div>
                                <TextInput
                                    id="reason"
                                    name="reason"
                                    type="text"
                                    required
                                    autoComplete="off"
                                    onChange={onChangeValue}
                                />
                            </div>

                            <div className="pt-3 w-full flex justify-center">
                                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit" onClick={(e) => handleRequest(e)}>
                                    Yes
                                </Button>
                                <Button className="ml-2" color="gray" onClick={() => setrequestModal(false)}>
                                    No
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <RequestActivityModal
                show={requestActivityModal}
                onClose={() => setrequestActivityModal(false)}
                requestActivityData={requestActivityData}
            />

        </>
    );
}

export default ReadytoSewing;
